import React from 'react';
import { Button, Modal, Spin } from 'antd';
import { withTranslation } from 'react-i18next';
import common from '@/asserts/js/common';
import { 
  closeImg,
  closeOnImg,
  closeOnLightImg,
  dropDownImg,
  dropDownOnImg,
  dropDownOnLightImg
} from '@/asserts/imgs/common/index';
import APPstyles from '@/App.less';
import styles from '../note/index.less';
import myStyles from './index.less';

class OnlineIndex extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      chgCloseImg:closeImg,
      isDropDownShow:false,
      chgDropDownImg:dropDownImg,
      dropDownIndex:0,
      chgAccount:'',
      accountData:[],
      getAid:'',
      isLoading:false,
      isSwitchAccount:false,
    }
  }
  btnClick(sign){
    const {isSwitchAccount} = this.state;
    this.props.cbBtnDataFun(sign, isSwitchAccount);
  }
  onMouseOver = () => {
    const {ChgThemeData} = this.props;
    let imgurl=ChgThemeData=='Light'?closeOnLightImg:closeOnImg;
    this.updateImage(imgurl);
  };
  onMouseOut = () => {
    this.updateImage(closeImg);
  };
  updateImage(imgurl) {
    const {isPC} = this.props;
    if(!isPC) return;
    this.setState({
      chgCloseImg: imgurl,
    });
  };
  dropDownClick(e){
    e.stopPropagation()
    this.setState(prevState => ({
      isDropDownShow:!prevState.isDropDownShow,
    }))
  }
  //点击外部关闭下拉框--cur
  handleClick = e => {
    if(!this.testComponent.contains(e.target)){
      this.setState ({
        isDropDownShow:false,
        chgDropDownImg:dropDownImg
      })
    }
  }
  // 选中某个
  choiceOneClick(data,index,e){
    const {getAid,isLoading}=this.state;

    e.stopPropagation();
    if(isLoading) return;

    const silderData=data['BranchName']+' '+data['AID']+' '+data['Name'];

    this.setState ({
      chgAccount:silderData,
      isDropDownShow:false,
      dropDownIndex:index,
      getAid:data['AID']
    });

    if(data['AID'] !== getAid){
      this.setState ({
        isSwitchAccount:true,
        isLoading:true
      });

      sessionStorage.setItem('aidListId', data['AID']);
      this.props.cbUpageAid(data['AID']);
      this.getAccountIdTokenFun(data['AID']);
    }
  }
  // 切换账号更改token
  getAccountIdTokenFun(getAid){
    fetch(common.getHttpZs+'getAccountIdToken',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
        account_id:getAid
      })
    })
    .then(res => res.json())
    .then(res => {
      //获取数据成功
      if(res['status']==0){
        const token=res['data']['token'];
        sessionStorage.setItem('token',token);
        this.getCustomerCurrency(token);
      }
      this.setState ({
        isLoading:false
      });
    })
  }
  // 查詢下單時各個市場是否使用台幣交易
  getCustomerCurrency(token){
    fetch(common.getHttpZs+'getCustomerCurrency',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:token,
      })
    })
    .then(res => res.json())
    .then(res => {
      if(res['status']==0){
        sessionStorage.setItem('customerCurrency',JSON.stringify(res['data']));
      }else{
        sessionStorage.setItem('customerCurrency',JSON.stringify([]));
      }
    })
  }
  //更换数据
  chgDataFun(aidListId, aidListData){
    const {accountData}=this.state;

    let getData=aidListData[aidListId];
    let aidData=Object.keys(aidListData);
    let newData=[];

    for(let i in aidData){
      newData.push(aidListData[aidData[i]]);
    }

    let index=newData.findIndex((item) => item['AID'] == aidListId);

    this.setState ({
      chgAccount: getData['BranchName'] + ' ' + getData['AID'] + ' ' + getData['Name'],
      dropDownIndex: index,
      getAid: getData['AID']
    });

    if(!accountData.length){
      this.setState ({
        accountData:newData
      });
    }
  }
  componentDidMount() {
    const {aid, aidListData}=this.props;

    const updaeAid = aid || sessionStorage.getItem('aidListId');
    const updaeAidListData = aidListData || JSON.parse(sessionStorage.getItem('aidListData'));

    this.chgDataFun(updaeAid, updaeAidListData);

    document.addEventListener('click', this.handleClick);
  };

  // 卸载
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  render(){
    const {t,isMobile,isPC,ChgThemeData,visible}=this.props;
    const {chgCloseImg,chgAccount,isDropDownShow,chgDropDownImg,accountData,dropDownIndex,isLoading}=this.state;
    return (
      <Modal 
        centered={true}
        closeIcon={null}
        footer={null}
        maskClosable={false}
        open={visible}
        transitionName=''
        maskTransitionName=''
        className={[ChgThemeData==='Light'?styles.modalLight:'',isMobile?styles.modalMobile:''].join(' ')}
      >
        <div className={[styles.noteTitle,APPstyles.flex_between,ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white,ChgThemeData==='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark].join(' ')}>
          <span>{t('線上簽署')}</span>
          <img 
            src={chgCloseImg} 
            className={APPstyles.img24} 
            onClick={()=>this.btnClick('N')}
            onMouseOver={()=>this.onMouseOver()}
            onMouseOut={()=>this.onMouseOut()}
          />
        </div>
        <div className={[styles.noteContent,ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white].join(' ')}>
          <div className={[myStyles.switchConOut].join(' ')}>
            <div 
              className={[APPstyles.flex_between,myStyles.switchCon].join(' ')}
              onClick={this.dropDownClick.bind(this)}
                onMouseOver={()=>{
                  if(!isPC) return
                  let imgurl=ChgThemeData=='Light'?dropDownOnLightImg:dropDownOnImg
                  this.setState({
                    chgDropDownImg:imgurl
                  })
                }} 
                onMouseOut={()=>{
                  if(!isPC) return
                  this.setState({
                    chgDropDownImg:dropDownImg
                  })
                }}
            >
              <span>{chgAccount}</span>
              <img 
                src={chgDropDownImg} 
                alt='dropDown' 
                className={myStyles.img_dropDown} 
                style={{transform:!isDropDownShow?'rotate(0deg)':'rotate(-180deg)'}}
              />
              <div className={APPstyles.isLoading}><Spin spinning={isLoading} /></div>
            </div>
              {/* 下拉框 */}
              <div 
                className={[
                  myStyles.dropsDown_con,
                  ChgThemeData=='Light'?myStyles.select_con_light:''
                ].join(' ')} 
                style={{display:isDropDownShow?'':'none'}} 
                ref = {testComponent => this.testComponent = testComponent}
              >
                {accountData.length > 0 &&
                  accountData.map((item,index) => {
                    return  <span 
                              key={index}
                              className={[
                                APPstyles.flex_row,
                                APPstyles.flex_topcenter,
                                ChgThemeData=='Light'?APPstyles.bg_event_light:APPstyles.btn_black,
                                dropDownIndex==index?ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.bg_event_black:''
                              ].join(' ')}
                              onClick={this.choiceOneClick.bind(this,item,index)}
                            >
                              {item['BranchName']+' '+item['AID']+' '+item['Name']}
                            </span>
                  })
                }
              </div>
          </div>
        </div>
        <div className={[styles.noteButton,isMobile&&styles.noteButtonM,APPstyles.flex_row].join(' ')}>
          <Button className={[APPstyles.bg_grey,APPstyles.btn_gray].join(' ')} onClick={()=>this.btnClick('N')}>
            {t('Cancel')}
          </Button>
          <Button 
            className={[APPstyles.bg_blue,APPstyles.btn_blue].join(' ')} 
            onClick={()=>this.btnClick('Y')}
          >
            {t('複委託風險預告書')}
          </Button>
        </div>
      </Modal>
  )}
}
export default withTranslation()(OnlineIndex);